import React from 'react';

import CuotaGrupo  from 'components/Tvendo/Sale/QuotaBPartner/Colgate/Periodo/CuotaGrupo/List.js';

export default function () {
  return <CuotaGrupo  />;
}